import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../utils/metaPixel';
export function FinalCTA() {
  return <section id="final-cta" className="w-full py-32 px-6 md:px-12 lg:px-24 bg-charcoal text-cream text-center relative overflow-hidden" data-id="element-39">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-amber via-charcoal to-charcoal" data-id="element-40"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-41">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="space-y-12" data-id="element-42">
          <h2 className="text-4xl md:text-6xl font-serif text-white leading-tight" data-id="element-43">
            "You already have the love.
            <br data-id="element-44" />
            <span className="text-amber-light" data-id="element-45">Now you have the method.</span>"
          </h2>

          <div className="pt-8 space-y-6" data-id="element-46">
            <div className="flex items-center justify-center gap-4" data-id="element-47">
              <span className="text-2xl md:text-3xl text-gray-500 line-through decoration-2" data-id="element-48">
                $47
              </span>
              <span className="text-5xl md:text-6xl font-serif text-white font-bold" data-id="element-49">
                $17
              </span>
            </div>
            <p className="text-amber-light font-semibold text-lg tracking-wide uppercase" data-id="element-50">
              65% Off — Launch Price
            </p>
            <a href="https://guiasparavivir.com/cart/52624055763233:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="inline-block w-full md:w-auto bg-amber hover:bg-amber-hover text-white font-bold text-xl md:text-2xl px-12 py-6 rounded-full transition-all duration-300 shadow-[0_0_30px_rgba(217,138,44,0.4)] hover:shadow-[0_0_50px_rgba(217,138,44,0.6)] transform hover:-translate-y-1 text-center" data-id="element-51">
              🔥 YES — I WANT THE CRISIS CALM METHOD
            </a>
            <p className="text-gray-400 mt-6 text-lg" data-id="element-52">
              Click the button above to get instant access to the complete
              bundle.
              <br data-id="element-53" />
              Everything downloads immediately. You can begin tonight.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}